import React from 'react'
import type { RefereeContext, FixtureClassificationContext } from '../types'

interface FixtureContextBannerProps {
  referee?: RefereeContext | null
  classification?: FixtureClassificationContext | null
}

export function FixtureContextBanner({ referee, classification }: FixtureContextBannerProps) {
  // Don't render if no meaningful context to show
  const hasClassification =
    classification?.is_derby || classification?.is_relegation_battle || classification?.is_title_race
  const hasReferee = referee && referee.strictness_label !== 'average'

  if (!hasClassification && !hasReferee) {
    return null
  }

  return (
    <div className="fixture-context-banner">
      {classification?.is_derby && (
        <span className="context-tag derby">
          <span className="context-icon">&#9917;</span>
          {classification.derby_name || 'Derby'}
        </span>
      )}
      {classification?.is_title_race && (
        <span className="context-tag title">
          <span className="context-icon">&#127942;</span>
          Title Race
        </span>
      )}
      {classification?.is_relegation_battle && (
        <span className="context-tag relegation">
          <span className="context-icon">&#128201;</span>
          Relegation Battle
        </span>
      )}
      {hasReferee && referee && (
        <span className={`context-tag referee ${referee.strictness_label}`}>
          <span className="context-icon">&#128110;</span>
          {referee.name}
          <span className="strictness-detail">
            ({referee.strictness_label}, {referee.yellows_per_90} Y/game)
          </span>
        </span>
      )}
    </div>
  )
}
